<app-header></app-header>
<mat-card class="form-card" *ngIf="!loading">
  <mat-card-header class="form-card-header">
    <mat-card-title>New Patient Sign-Up</mat-card-title>
  </mat-card-header>
  <form [formGroup]="profileForm">
    <div class="form-container">
      <!-- Personal Information Fields -->
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Last Name</mat-label>
        <input matInput formControlName="lastName" required>
        <mat-error *ngIf="profileForm.get('lastName')?.hasError('required')">
          Last Name is required
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>First Name</mat-label>
        <input matInput formControlName="firstName" required>
        <mat-error *ngIf="profileForm.get('firstName')?.hasError('required')">
          First Name is required
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Gender</mat-label>
        <mat-select formControlName="gender">
          <mat-option *ngFor="let gender of genders" [value]="gender">{{ gender }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Date of Birth (MM/DD/YYYY)</mat-label>
        <input matInput formControlName="dateOfBirth" autoSlashDateFormat placeholder="Enter date of birth (e.g., 01/01/2000)" [matDatepicker]="picker" required>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        <mat-error *ngIf="profileForm.get('dateOfBirth')?.hasError('required')">
          Date of Birth is required
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Phone Number</mat-label>
        <input matInput formControlName="phoneNumber" required>
        <mat-error *ngIf="profileForm.get('phoneNumber')?.hasError('required')">
          Phone Number is required
        </mat-error>
        <mat-error *ngIf="!(profileForm.get('phoneNumber')?.hasError('required')) && profileForm.get('phoneNumber')?.hasError('invalidPhoneNumber')">
          Invalid Phone Number
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Email</mat-label>
        <input matInput formControlName="email" required>
        <mat-error *ngIf="profileForm.get('email')?.hasError('required')">
          Email is required
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Text Message Consent</mat-label>
        <mat-select formControlName="textMessageConsent">
          <mat-option value="Yes">Yes</mat-option>
          <mat-option value="No">No</mat-option>
          <mat-option value="Unknown">Unknown</mat-option>
        </mat-select>
      </mat-form-field>
      
      <div class="consent-message">
        <small>
          By providing your phone number and selecting "Yes" for text message consent, you agree to receive
          SMS/text messages from your healthcare practice regarding appointments, reminders, and other
          healthcare-related communications. Consent is not a condition of treatment. Message frequency varies.
          Msg &amp; data rates may apply. Reply HELP for help or STOP to opt out.
          View our <a routerLink="/privacy">Privacy Policy</a> and <a routerLink="/terms">Terms of Service</a>.
        </small>
      </div>

      <div class="button-container">
        <button mat-raised-button color="primary" type="submit" (click)="onSave()" [disabled]="!isFormEdited">Register</button>
        <button mat-raised-button color="warn" type="button" (click)="onCancel()">Cancel</button>
      </div>
    </div>
  </form>
</mat-card>

<div class="loading-container" *ngIf="loading">
  <mat-spinner [diameter]="50" [color]="'primary'"></mat-spinner>
</div>
